export default {
      id: "ic_withdrawable_balance-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_withdrawable_balance-usage",
      toString: function () {
        return this.url;
      }
    }